import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    ref: "card_element",
    class: "form-control",
    style: { "height": "2.6em", "padding-top": ".7em", "padding-bottom": ".7em" }
};
const _hoisted_2 = {
    key: 0,
    class: "text-danger mb-1 mt-1",
    role: "alert"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_container = _resolveComponent("g-field-container");
    const _component_g_text_field = _resolveComponent("g-text-field");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_g_field_container, { label: "Kreditakarten-Nummer" }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, null, 512)
            ]),
            _: 1
        }),
        _createVNode(_component_g_text_field, {
            label: "Besitzer (Name auf Kreditkarte)",
            "validation-rules": { required: true },
            "data-object": _ctx.$data,
            "data-member": "cardName",
            "data-mode": "model"
        }, null, 8, ["data-object"]),
        (_ctx.paymentErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.paymentErrors), 1))
            : _createCommentVNode("", true)
    ], 64));
}
